module.exports = __webpack_public_path__ + "70f7443c5d8bf7f4930907e13fb3d30b.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/head/hair-scarf-yellow.png
// module id = 2233
// module chunks = 0